import { useEffect } from "react";
import { toast } from "react-toastify";

import { useRealTimeTypedQuery } from "components/WebSocket/hooks";
import { typedQueryClient } from "hooks/useTypedQuery";
import { useDealerLicensesDashboardFilters } from "modules/DealerLicenseOverview/hooks/useDealerLicensesFilters";
import { useDealerLicenseOverviewListeners } from "modules/DealerLicenseOverview/listeners";
import { DealerLicenseQueryKeys } from "modules/DealerLicenseOverview/queryKeys";
import { transformData } from "modules/LocationLicenseOverview/utils";
import { ApiInstance } from "utils/Api";

export const useDealerLicensesQuery = () => {
  const { dealer } = useDealerLicensesDashboardFilters();
  const listeners = useDealerLicenseOverviewListeners({ selectedDealer: dealer });

  const query = useRealTimeTypedQuery({
    queryKey: DealerLicenseQueryKeys.licenses,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_id: dealer?.id }, baseUrl)).data,
    select: transformData,
    enabled: Boolean(dealer?.id && dealer.is_exact_invoicing_enabled),
    listeners
  });

  useEffect(() => {
    if (dealer?.id && dealer.is_exact_invoicing_enabled) query.refetch();
    else if (!dealer?.is_exact_invoicing_enabled) typedQueryClient.resetQueries(DealerLicenseQueryKeys.licenses);
  }, [dealer?.id]);

  useEffect(() => {
    if (query.error) toast.error(query.error.message);
  }, [query.error]);

  return query;
};
